import type { ReactNode } from "react";
import { CheckCircle2, Circle, Download } from "lucide-react";

interface Props {
  title: string;
  subtitle?: string;
  amount?: string;
  downloaded: boolean;
  onDownload: () => void;
  rightExtra?: ReactNode;
}

export function DocumentRow({ title, subtitle, amount, downloaded, onDownload, rightExtra }: Props) {
  return (
    <div className="flex items-center gap-3 py-3 px-4 border-b border-border last:border-0 hover:bg-card transition-colors">
      <div className="shrink-0" aria-hidden>
        {downloaded ? (
          <CheckCircle2 size={20} className="text-success" />
        ) : (
          <Circle size={20} className="text-muted" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm text-ink truncate">{title}</p>
        {subtitle && <p className="text-xs text-muted truncate">{subtitle}</p>}
      </div>
      {amount && <div className="shrink-0 font-mono text-sm text-ink">{amount}</div>}
      {rightExtra}
      <button
        onClick={onDownload}
        aria-label={`Télécharger ${title}`}
        className="shrink-0 p-2 rounded-lg text-terracotta hover:bg-terracotta/10"
      >
        <Download size={18} />
      </button>
    </div>
  );
}
